import { EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * Links the selected therapies to an appointment.
 * POST /api/master/encounter-summary/therapy/{appointmentUuid}
 *
 * The generated client types the body as `Set<string>`, but the request is
 * JSON-serialized via `JSON.stringify`, which turns a real `Set` into `{}`.
 * We therefore pass a plain string array and cast it to satisfy the type.
 *
 * @author Rajkumar Rathod
 */
export const useLinkTherapiesToAppointment = () =>
  useMutationWithLoading(
    async (params: {
      appointmentUuid: string;
      therapies: Array<string>;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).linkTherapiesToAppointment(
        params.appointmentUuid,
        params.therapies as unknown as Set<string>,
        params.xTENANTID
      )
  );
